import Vue from "vue"
import App from "./app.vue"
import router from "./initializers/router.js"

import "./initializers/luxon.js"

import "bootstrap"

import "@/assets/css/screen.scss"

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount("#app")
